import Janus from '../external/janus.es'
import enableScreenRecording from './janussession'
import { sendParent, forwardTo } from 'xstate'


// top 
const sipCtiSubscribeStates = {
    initial: 'inactive',
    states: {
        inactive: {
            on: {
                SUBSCRIBE: { target: 'tryingSubscribe', cond: context => context.instanceId == 0 && context.pbxPlaform !== "cucm" }
            }
        },
        notAllowed: {},
        unsubscribed: {
            after: { 30000: 'tryingSubscribe' },
            on: {
                SUBSCRIBE: 'tryingSubscribe',
            }
        },
        tryingSubscribe: {
            entry: subscribeAction,
            on: {
                SUBSCRIBING: {},
                SUBSCRIBE_FAILED: [
                    { target: 'unsubscribed', cond: (context, event) => event.result["code"] !== 405, actions: sendParent((context, event) => ({ type: 'PLUGIN_CTI_SUBSCRIBE_FAILED', instanceId: context.instanceId })) },
                    { target: 'notAllowed' }
                ],
                SUBSCRIBE_SUCCEEDED: 'subscribed',
            }
        },
        subscribed: {
            invoke: {
                id: 'notifyProcessor',
                src: (context, event) => (callback, onReceive) => {
                    onReceive(e => {
                        processNotifyAction(e, callback);
                    });

                }

            },
            on: {
                SUBSCRIBE_FAILED: { target: 'unsubscribed', actions: sendParent((context, event) => ({ type: 'PLUGIN_CTI_SUBSCRIBE_FAILED', instanceId: context.instanceId })) },
                SUBSCRIBE_SUCCEEDED: {},
                UNSUBSCRIBE: { actions: unsubscribeAction },
                NOTIFY: { actions: forwardTo('notifyProcessor'), cond: (context, event) => event.result["notify"] === "ipfx-cti" },
                CTI_MWI: { actions: sendParent((context, event) => event) },
                CANCEL_PENDING_CALL: { actions: sendParent((context, event) => event) },
                CTI_ANSWER: { actions: sendParent((context, event) => event) },
                CTI_HOLD: { actions: sendParent((context, event) => event) },
                CTI_RESUME: { actions: sendParent((context, event) => event) },
                CTI_DIAL: { actions: sendParent((context, event) => event) },
                START_CAPTURE: { actions: sendParent((context, event) => event) },
                STOP_CAPTURE: { actions: sendParent((context, event) => event) },
                SUSPEND_CAPTURE: { actions: sendParent((context, event) => event) },
                RESUME_CAPTURE: { actions: sendParent((context, event) => event) },
                ADD_CAPTURE_ON_DEMAND_OPTION: { actions: sendParent((context, event) => event) },
                REMOVE_CAPTURE_ON_DEMAND_OPTION: { actions: sendParent((context, event) => event) },
                CAPTURE_ON_DEMAND_COMPLETE: { actions: sendParent((context, event) => event) },                
            }
        }
    } // states
}

function subscribeAction(context, event) {
    let subscribe = {
        "request": "subscribe",
        "event": "ipfx-cti;opaque-id=" + context.opaqueId,
        "accept": "application/xml"
    };
    context.pluginHandle.send({ message: subscribe });
}

function unsubscribeAction(context, event) {
    if (event.removeToken && context.pushToken) {
        let unsubscribe = { "request": "unsubscribe", "event": "ipfx-cti;opaque-id=" + context.opaqueId + ";remove-token=" + '"' + context.pushToken + '"', "accept": "application/xml" };
        context.pluginHandle.send({ message: unsubscribe });
    } else{
        let unsubscribe = { "request": "unsubscribe", "event": "ipfx-cti;opaque-id=" + context.opaqueId, "accept": "application/xml" };
        context.pluginHandle.send({ message: unsubscribe });
    }
}



function processNotifyAction(event, callback) {
    let result = event.result;
    let event_package = result["notify"]
    Janus.log("Got NOTIFY *, event package: " + result["notify"]);
    if (event_package === "ipfx-cti") {
        let content_type = result["content-type"];
        let content = result["content"];
        if (content_type === "application/xml" && content) {
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(content, "application/xml");
            //let endpointNode = xmlDoc.getElementsByTagName("Endpoint")[0];
            // let notifyExtension =
            // 	endpointNode.getElementsByTagName("Extension")[0].childNodes[0]
            // 		.nodeValue;
            // let notifyOpaqueId =
            // 	xmlDoc.getElementsByTagName("OpaqueId")[0].childNodes[0].nodeValue;
            let notifyHelperId = 0;
            if (xmlDoc.getElementsByTagName("HelperId").length > 0) {
                // ommit the first char "C", i.e. from "C1"
                let fullHelperId =
                    xmlDoc.getElementsByTagName("HelperId")[0].childNodes[0]
                        .nodeValue;
                if (fullHelperId.length > 1) {
                    notifyHelperId = fullHelperId.substring(1);
                }
            }
            let mwlValue = false;
            let hasMwlvalue = false;
            let dialTargetUri = "";
            let cancelCallId = "";
            if (xmlDoc.getElementsByTagName("MWL").length > 0) {
                let notifyMWlNodes = xmlDoc.getElementsByTagName("MWL")[0];
                let v =
                    notifyMWlNodes.getElementsByTagName("Status")[0].childNodes[0]
                        .nodeValue;
                mwlValue = (v === 'true');
                hasMwlvalue = true;
            } else if (xmlDoc.getElementsByTagName("Capture").length > 0) {
                if (enableScreenRecording)
                {
                    let captureNode = xmlDoc.getElementsByTagName("Capture")[0];
                    let captureStart = captureNode.getElementsByTagName("Start")[0].childNodes[0].nodeValue;
                    if (captureStart === "1")
                    {
                        let captureTarget = captureNode.getElementsByTagName("CaptureTarget")[0].childNodes[0].nodeValue;
                        let captureCallId = captureNode.getElementsByTagName("CaptureCallId")[0].childNodes[0].nodeValue;
                        let captureFrameRate = captureNode.getElementsByTagName("CaptureFrameRate")[0].childNodes[0].nodeValue;
                        let captureScreenWidth = captureNode.getElementsByTagName("CaptureScreenWidth").length > 0 ? captureNode.getElementsByTagName("CaptureScreenWidth")[0].childNodes[0].nodeValue : undefined;
                        let captureScreenHeight = captureNode.getElementsByTagName("CaptureScreenHeight").length > 0 ? captureNode.getElementsByTagName("CaptureScreenHeight")[0].childNodes[0].nodeValue : undefined;
                        let optionCaptureOnDemand = captureNode.getElementsByTagName("OptionCaptureOnDemand").length > 0 ? captureNode.getElementsByTagName("OptionCaptureOnDemand")[0].childNodes[0].nodeValue : undefined;
                        let optionCaptureOnDemandTag = captureNode.getElementsByTagName("OptionCaptureOnDemandTag").length > 0 ? captureNode.getElementsByTagName("OptionCaptureOnDemandTag")[0].childNodes[0].nodeValue : undefined;
                        let optionRecordAudio = captureNode.getElementsByTagName("OptionRecordAudio").length > 0 ? captureNode.getElementsByTagName("OptionRecordAudio")[0].childNodes[0].nodeValue : undefined;
                        callback({ 
                            type: 'START_CAPTURE', 
                            callId: captureCallId, 
                            target: captureTarget, 
                            frameRate: captureFrameRate, 
                            screenWidth: captureScreenWidth, 
                            screenHeight: captureScreenHeight,
                            optionCaptureOnDemand: optionCaptureOnDemand,
                            optionCaptureOnDemandTag: optionCaptureOnDemandTag,
                            optionRecordAudio: optionRecordAudio
                        });
                    } else if (captureStart === "0") {
                        callback({ type: 'STOP_CAPTURE' });
                    } else if (captureStart === "2") {
                        let captureNode = xmlDoc.getElementsByTagName("Capture")[0];
                        let newCaptureCallId = captureNode.getElementsByTagName("CaptureCallId")[0].childNodes[0].nodeValue;
                        if (captureNode.getElementsByTagName("OptionCaptureOnDemand").length > 0) {
                            let optionCaptureOnDemand = captureNode.getElementsByTagName("OptionCaptureOnDemand")[0].childNodes[0].nodeValue;
                            if (optionCaptureOnDemand !== "0") {
                                let optionCaptureOnDemandTag = captureNode.getElementsByTagName("OptionCaptureOnDemandTag").length > 0 ? captureNode.getElementsByTagName("OptionCaptureOnDemandTag")[0].childNodes[0].nodeValue : undefined;                        
                                let optionRecordAudio = captureNode.getElementsByTagName("OptionRecordAudio").length > 0 ? captureNode.getElementsByTagName("OptionRecordAudio")[0].childNodes[0].nodeValue : undefined;
                                callback({ type: 'ADD_CAPTURE_ON_DEMAND_OPTION', newCallId: newCaptureCallId, optionCaptureOnDemand: optionCaptureOnDemand, optionCaptureOnDemandTag: optionCaptureOnDemandTag, optionRecordAudio: optionRecordAudio });
        
                            } else if (captureNode.getElementsByTagName("OptionCaptureOnDemand")[0].childNodes[0].nodeValue === "0") {
                                callback({ type: 'REMOVE_CAPTURE_ON_DEMAND_OPTION',  newCallId: newCaptureCallId,});
                            }
                        }
                    }
                }
            } else if (xmlDoc.getElementsByTagName("CapturePrivacy").length > 0) {
                if (enableScreenRecording)
                {
                    let node = xmlDoc.getElementsByTagName("CapturePrivacy")[0];
                    let value = node.getElementsByTagName("Active")[0].childNodes[0].nodeValue;
                    if (value === "0")
                    {
                        callback({ type: 'RESUME_CAPTURE' });                        
                    } else {
                        callback({ type: 'SUSPEND_CAPTURE' });
                    }
                }
            } else if (xmlDoc.getElementsByTagName("CaptureOnDemandComplete").length > 0) {
                if (enableScreenRecording)
                {
                    let node = xmlDoc.getElementsByTagName("CaptureOnDemandComplete")[0];
                    let recordingTag = undefined;
                    if (node.getElementsByTagName("OptionCaptureOnDemandTag")[0].childNodes.length > 0) {
                        recordingTag = node.getElementsByTagName("OptionCaptureOnDemandTag")[0].childNodes[0].nodeValue;
                    }
                    let recordingFilename = node.getElementsByTagName("Filename")[0].childNodes[0].nodeValue;
                    let recordingStartTimeUtc = node.getElementsByTagName("StartTime")[0].childNodes[0].nodeValue;
                    let recordingEndTime = node.getElementsByTagName("EndTime")[0].childNodes[0].nodeValue;
                    callback({
                        type: 'CAPTURE_ON_DEMAND_COMPLETE',
                        recordingTag: recordingTag,
                        recordingFilename: recordingFilename,
                        recordingStartTimeUtc: recordingStartTimeUtc,
                        recordingEndTime: recordingEndTime,
                    });
                }
            } else if (xmlDoc.getElementsByTagName("MakeCall").length > 0) {
                let notifyMWlNodes = xmlDoc.getElementsByTagName("MakeCall")[0];
                dialTargetUri =
                    notifyMWlNodes.getElementsByTagName("Target")[0].childNodes[0]
                        .nodeValue;
            } else if (xmlDoc.getElementsByTagName("PendingCallTerminated").length > 0) {
                let notifyMWlNodes = xmlDoc.getElementsByTagName("PendingCallTerminated")[0];
                cancelCallId =
                    notifyMWlNodes.getElementsByTagName("Call-id")[0].childNodes[0]
                        .nodeValue;
            }
            let notifyAction = "";
            if (xmlDoc.getElementsByTagName("Action").length > 0) {
                notifyAction = xmlDoc.getElementsByTagName("Action")[0].childNodes[0]
                    .nodeValue;
            }
            if (notifyAction) {
                if (notifyAction === "Hold") {
                    // doCtiHold(notifyHelperId);
                    callback({ type: 'CTI_HOLD', instanceId: notifyHelperId });
                } else if (notifyAction === "Resume") {
                    // doCtiResume(notifyHelperId);
                    callback({ type: 'CTI_RESUME', instanceId: notifyHelperId });
                } else if (notifyAction === "Answer") {
                    //doCtiAnswer();
                    callback({ type: 'CTI_ANSWER', instanceId: notifyHelperId });
                }
            }
            else if (hasMwlvalue) {
                Janus.log("MWL value is [" + mwlValue + "]");
                callback({ type: 'CTI_MWI', mwi: mwlValue });
            }
            else if (dialTargetUri) {
                Janus.log("MakeCall [" + dialTargetUri + "]");
                // doCtiCall(dialTargetUri, false);
                callback({ type: 'CTI_DIAL', dialUri: dialTargetUri });
            }
            else if (cancelCallId) {
                callback({ type: 'CANCEL_PENDING_CALL', callId: cancelCallId });
            }
        }
    }

}


export { sipCtiSubscribeStates };
